import { City } from '@ekt-group/general-purpose-api-interfaces';

import { useFetch } from '@/lib/react-query';
import { apiRoutes } from '@/utils/routes';

export const useGetCities = () => useFetch<City[]>(apiRoutes.getCities);
